var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import autobind from "autobind-decorator";
import { computed, observable, action } from "mobx";
import { logger, cloneDeepSafe } from "@lib/common";
let Store = class Store {
    constructor(fetch) {
        this.s = {
            items: [],
            count: 0,
            dropdown: "",
            limit: 25,
            page: 1,
            search: "",
            sortKey: "created",
            sortDirection: -1,
            filtersActive: {},
            fromDate: undefined,
            toDate: undefined,
            loading: true,
            error: "",
        };
        this.update = (data) => {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const value = data[key];
                    if (value !== undefined) {
                        //@ts-ignore
                        this.s[key] = value;
                    }
                }
            }
        };
        this.fetch = async () => {
            this.update({ loading: true, error: "", dropdown: "" });
            try {
                const { page, limit, search, sortDirection, sortKey, filtersActive, fromDate, toDate, } = this.s;
                const filters = cloneDeepSafe(filtersActive);
                for (const key in filters) {
                    if (filters.hasOwnProperty(key) &&
                        filters[key].$in.length === 0) {
                        delete filters[key];
                    }
                }
                const fetchData = {
                    page: page,
                    limit: limit,
                    sort: { [sortKey]: sortDirection },
                    query: filters,
                };
                if (search)
                    fetchData.search = search;
                if (fromDate && toDate) {
                    fetchData.dateRange = {
                        start: fromDate,
                        end: toDate,
                    };
                }
                await this._fetch(fetchData);
                this.update({
                    loading: false,
                });
            }
            catch (e) {
                logger.captureException(e);
                this.update({
                    loading: false,
                    error: "Error loading items, try again or contact us",
                });
            }
        };
        this.reset = () => {
            this.update({
                search: "",
                sortKey: "created",
                sortDirection: -1,
                filtersActive: {},
            });
        };
        this.setPage = (page) => {
            this.s.page = page;
            this.fetch();
        };
        this.filterToggle = (key, value) => {
            if (this.s.filtersActive[key]) {
                const index = this.s.filtersActive[key].$in.indexOf(value);
                if (index === -1)
                    this.s.filtersActive[key].$in.push(value);
                else
                    this.s.filtersActive[key].$in.splice(index, 1);
            }
            else {
                this.s.filtersActive[key] = { $in: [value] };
            }
        };
        this.filterIsActive = (key, value) => {
            if (this.s.filtersActive[key]) {
                const index = this.s.filtersActive[key].$in.indexOf(value);
                return index !== -1;
            }
            else {
                return false;
            }
        };
        this._fetch = fetch;
    }
    get totalPages() {
        return Math.ceil((this.s.count || 1) / this.s.limit);
    }
};
__decorate([
    observable
], Store.prototype, "s", void 0);
__decorate([
    computed
], Store.prototype, "totalPages", null);
__decorate([
    action
], Store.prototype, "update", void 0);
__decorate([
    action
], Store.prototype, "fetch", void 0);
__decorate([
    action
], Store.prototype, "reset", void 0);
__decorate([
    action
], Store.prototype, "setPage", void 0);
__decorate([
    action
], Store.prototype, "filterToggle", void 0);
Store = __decorate([
    autobind
], Store);
export { Store };
//# sourceMappingURL=store.js.map